<template>
  <div>
    <b-modal
      @ok="createUser"
      @cancel="hideModal"
      no-close-on-backdrop
      ref="ModalUnitAndBatch"
      size="lg"
      title="Suspend List"
      centered
      hide-footer
    >
      <b-row v-if="loading" class="d-flex justify-content-center">
        <b-spinner
          style="width: 3rem; height: 3rem;"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </b-row>
      <b-row
        v-if="suspend_lists.length == 0 && !loading"
        class="pl-3 pr-3 text-center"
      >
        <b-col>
          <b-alert show variant="warning">No Suspend Sales Found</b-alert>
        </b-col>
      </b-row>
      <b-row v-if="suspend_lists.length != 0 && !loading">
        <b-col cols="6" class="text-center ">
          <!-- <h4 class="font-poppins">Units</h4> -->
          <div v-for="(suspend, index) in suspend_lists" :key="index">
            <div
              @click="selectSuspendItem(suspend)"
              :class="
                suspend.id == selected.id ? 'unit m-1 selected' : 'unit m-1'
              "
            >
              {{ suspend.comment }} ({{ suspend.data | length }} products)
              <!-- <div v-for="(product, index) in suspend.data[0]" :key="index">
                {{ product.name }}
              </div> -->
            </div>
          </div>
        </b-col>
        <b-col cols="6" class="text-center ">
          <div v-if="selected.data">
            <h6 class="font-poppins">Added Products</h6>
            <table class="table table-borderless table-hover table-vcenter">
              <tbody>
                <tr class="table_heading">
                  <th class="pl-3">Product</th>
                  <th class="text-left pl-2">Price</th>
                  <th class="text-center">Qty</th>
                  <th class="text-right pr-4">Subtotal</th>
                </tr>
                <tr
                  v-for="(item, index) in selected.data"
                  :key="index"
                  style="border-bottom:1px solid #c1c1c1"
                >
                  <td>
                    {{ item.name }}
                  </td>
                  <td class="text-left">
                    <div class="font-w600 text-success amount_area ">
                      {{ item.price }}
                    </div>
                  </td>
                  <td class="text-center">
                    {{ item.quantity }}
                  </td>
                  <td class="text-right">
                    <div class="font-w600 text-success amount_area ">
                      {{ (item.price * item.quantity) | amount }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-right">
              <b-btn
                @click="RemoveSuspendSale(selected.id)"
                variant="danger"
                class="w-50"
                :disabled="applySalesLoading"
              >
                <div v-if="!removeSalesLoading">Remove</div>
                <b-spinner v-else small></b-spinner>
              </b-btn>
              <b-btn
                :disabled="removeSalesLoading"
                @click="ApplySale(selected.data)"
                variant="warning"
                class="w-50"
              >
                <div v-if="!applySalesLoading">Apply</div>
                <b-spinner v-else small></b-spinner>
              </b-btn>
            </div>
          </div>
        </b-col>
        <!-- <b-col cols="6" class="text-center">
          <h4 class="font-poppins">Batch</h4>
          <div v-for="(batch, index) in selectedUnit.batches" :key="index">
            <div
              @click="selectBatch(batch)"
              :class="
                batch.id == selectedBatch.id
                  ? 'batch m-1 selected'
                  : 'batch m-1'
              "
            >
              <b-row @click.stop="selectBatch(batch)">
                <b-col>
                  <div class="font-poppins">{{ batch.batch }}</div>
                </b-col>
                <b-col>
                  <div class="font-poppins">{{ batch.selling_price }}/=</div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col> -->
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { ProductModel } from "@/models/ProductModel";
import { mapState } from "vuex";

export default {
  name: "SuspendSales",
  methods: {
    ApplySale(item) {
      this.applySalesLoading = true;
      this.$store.commit("bill/APPLY_SALE", item);
      this.showToast("Successfully applied", "success");
      this.applySalesLoading = false;
      this.hideModal();
      this.RemoveSuspendSale(this.selected.id, false);
    },
    RemoveSuspendSale(id, toast = true) {
      this.removeSalesLoading = true;
      this.$store
        .dispatch("bill/RemoveSuspendSale", id)
        .then((res) => {
          if (toast) {
            this.showToast("Successfully removed", "success");
          }
          this.fetchSuspendLists();
          this.removeSalesLoading = false;
        })
        .catch((err) => {
          this.removeSalesLoading = false;
          if (toast) {
            this.showToast("Suspend sales failed to remove", "warning");
          }
        });
    },
    initiate() {
      this.fetchCount = 0;
      this.product = Object.assign({}, ProductModel);
      this.selected = {};
      // this.selectedBatch = {};
    },
    selectSuspendItem(item) {
      this.selected = item;
    },
    selectBatch(batch) {
      this.selectedBatch = batch;
      this.$emit("addProduct", {
        batch: batch,
        unit: this.selected,
      });
      this.hideModal();
    },
    fetchSuspendLists() {
      this.loading = true;
      var productId = this.data.id;
      this.$store
        .dispatch("bill/fetchSuspendList")
        .then((res) => {
          this.loading = false;
          // if (res.status == 200 && res.data != null) {
          //   this.suspend_lists = res.data.data;
          // } else if (res.status == 204) {
          //   this.suspend_lists = [];
          //   this.reloadContent();
          // } else {
          //   this.suspend_lists = [];
          // }
        })
        .catch((err) => {
          this.loading = false;
          // this.suspend_lists = [];
        });
    },
    reloadContent() {
     
      if (this.fetchCount < 2) {
        this.fetchSuspendLists();
        this.fetchCount++;
      }
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant: variant,
        solid: true,
      });
    },
    showModal() {
      this.loading = true;
      this.initiate();
      setTimeout(() => {
        this.fetchSuspendLists();
      }, 200);
      this.$refs["ModalUnitAndBatch"].show();
    },
    hideModal() {
      this.$refs["ModalUnitAndBatch"].hide();
    },
    createUser() {},
  },
  props: {
    data: {
      type: Array,
           default: function () {
          return []
      }
    },
  },
  data: () => ({
    // dialog: false
    // tab: 0,
    loading: null,
    // suspend_lists: [{ id: 1, name: "save01" }],
    product: Object.assign({}, ProductModel),
    selected: {},
    // selectedBatch: [],
    fetchCount: 0,
    removeSalesLoading: false,
    applySalesLoading: false,
  }),
  filters: {
    length: function(value) {
      return value.length;
    },
  },
  computed: {
    ...mapState("bill", ["suspend_lists"]),
  },
  mounted: function() {
    // this.initialize();
  },
};
</script>

<style>
.unit,
.batch {
  font-family: "Poppins";
  font-weight: 600;
  padding: 20px 11px;
  border: 1px solid #634a00;
  border-radius: 11px;
  /* width: 200px; */
  text-align: center;
  box-shadow: 1px 1px 0px 0px black;
}
.selected {
  background-color: #ffc107;
  color: #162947;
  box-shadow: unset;
  border: 1px solid white;
}
.unit:hover,
.unit:active,
.batch:hover {
  background-color: #ffd557;
  border: 1px solid #ffd557;
  color: #162947;
}
</style>
